// Custom Filters Js 
// Hook into Dawn's filter apply event

// In assets/global.js or facets.js
const observer = new MutationObserver((mutations) => {
  mutations.forEach((mutation) => {
    if (mutation.type === 'attributes' && mutation.attributeName === 'open') {
      const form = mutation.target.closest('.mobile-facets__main details');
      if (form && window.innerWidth <= 749 && !form.hasAttribute('open')) {
        form.setAttribute('open', '');
      }
    }
  });
});

observer.observe(document.body, { 
  attributes: true, 
  subtree: true, 
  attributeFilter: ['open'] 
});


document.body.addEventListener("click", event => {
    const categoryButton = event.target.closest(".plp-category-button");
    if (categoryButton) {
        const textContent = categoryButton.querySelector(".plp-category-button-text").innerText.trim();
     
        categoryButton.classList.contains("active-category") || (document.querySelectorAll(".plp-category-button").forEach(button => {
            button.classList.remove("active-category")
        }), categoryButton.classList.add("active-category")), uncheckAllCheckboxes(), clickCheckboxByLabel(textContent), event.stopImmediatePropagation()
    }
});

function uncheckAllCheckboxes() {
    document.querySelectorAll('.facet-checkbox input[type="checkbox"]').forEach(checkbox => {
        checkbox.checked = !1, checkbox.dispatchEvent(new Event("change"))
    })
}

function clickCheckboxByLabel(labelText) {

    document.querySelectorAll(".facet-checkbox").forEach(label => {
        if (label.querySelector("span.facet-checkbox__text, span").innerHTML.replace(/[0-9\[\]()]/g, "").trim() == labelText.trim()) {
            const checkbox = label.querySelector('input[type="checkbox"]');
            if (checkbox) {
                console.log('checkbox');
                const mouseEvent = new MouseEvent("click", {
                    bubbles: !0,
                    cancelable: !0,
                    composed: !0
                });
                checkbox.dispatchEvent(mouseEvent), checkbox.dispatchEvent(new Event("change"))
            }
        }
    })
}
document.addEventListener("DOMContentLoaded", () => {
    setInitialActiveCategoryFromURL()
});

function setInitialActiveCategoryFromURL() {
    const subcategory = new URLSearchParams(window.location.search).get("filter.p.m.custom.custom_collection_filters");
   console.log('subcategory: '+subcategory);
    if (!subcategory) return;
    const allCategoryButtons = document.querySelectorAll(".plp-category-button");
    allCategoryButtons.forEach(button => {
        button.classList.remove("active-category")
    }), allCategoryButtons.forEach(button => {
        const categoryTextElement = button.querySelector(".plp-category-button-text");
        categoryTextElement && categoryTextElement.innerText.replace(/[0-9\[\]()]/g, "").trim().toLowerCase() === subcategory.toLowerCase() && (button.classList.add("active-category"), uncheckAllCheckboxes(), clickCheckboxByLabel(categoryTextElement.innerText.trim()))
    })
}